import React, { useState, useContext, useEffect, useRef } from "react";
import { GlobalContext } from "../../../App";
import "../../BoundaryCanvas";
import L from "leaflet";

function SpiltVetorLayers() {
  const [show, setShow] = useState(false);
  const [vectors, setVectors] = useState([]);
  const [selLayer1, setSelLayer1] = useState(null);
  const [selLayer2, setSelLayer2] = useState(null);
  const { vis, layerControls, Canvas,map } = useContext(GlobalContext);
  const toolvisRef = useRef(null);

  useEffect(() => {
    // if (layerControls && show) {
    if (layerControls ) {
      setVectors(Canvas.getLayers());
    }
    setSelLayer1(null);
    setSelLayer2(null);
  }, [show, Canvas, layerControls]);

  const close = () => setShow(false);

    function split() {
      const splitResults = Canvas.splitVectorLayer(selLayer1, selLayer2);

      if (!splitResults || Object.keys(splitResults).length === 0) {
        console.error("No valid split results returned.");
        return;
      }

       Canvas.setLayerVisibility(selLayer2, false);

      Object.entries(splitResults).forEach(([regionName, data]) => {
        const layerId = data[0];
        const bbox = data[1];

        const bounds = L.latLngBounds(
          L.latLng(bbox[0], bbox[1]),
          L.latLng(bbox[2], bbox[3])
        );

        // Create a dummy Leaflet layer that satisfies layerControls.addOverlay
        // This is the same pattern used for deck.gl layers elsewhere in your app
        const dummyLayer = L.layerGroup();

        layerControls.addOverlay(
          dummyLayer,
          regionName,
          true,
          bounds,
          true,
          regionName,
          false,
          null
        );
      });
}


  // Utility to assign different colors to each region (optional)
  function getRandomColor() {
    const colors = ['#ff6347', '#1e90ff', '#32cd32', '#ffa500', '#6a5acd', '#ff1493'];
    return colors[Math.floor(Math.random() * colors.length)];
  }  
  
  function splitDownload() {
    // Optionally call a download method if you have one, for example:
    Canvas.splitVectorLayerDownload(selLayer1, selLayer2, `${selLayer1}_inside_${selLayer2}`, true);
  }

  return (
    <div 
    // style={{ position: vis ? "absolute" : "relative" }} className="toolscont"
    >
      {/* <button
        title="Vector Layer Splitting Tool"
        className="btn text-white"
        onClick={() => setShow((prev) => !prev)}
        style={{
          zIndex: "1000",
          fontSize: "15px",
          backgroundColor: "black",
          padding: "2px",
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          border: "none",
        }}
      >
        Split
      </button>
      {show && (
        <div
          ref={toolvisRef}
          className="toolsvis"
          id="toolvis"
          style={{ display: "flex", flexDirection: "column", width: "200px" }}
        >
          <span onClick={close} className="toolclose">
            &times;
          </span> */}

          {/* Select the first vector layer (e.g., polygon for extent) */}
          <select
            onChange={(e) => setSelLayer1(e.target.value)}
            value={selLayer1}
            className="form-select text-white mt-3 swipe-options" style={{ marginBottom: "5px", backgroundColor:'transparent', border:'2px solid white', fontSize: '13px' }}
          >
            <option value="">Select First Vector Layer</option>
            {vectors.map((comp) => (
              <option key={comp} value={comp}>
                {comp}
              </option>
            ))}
          </select>

          {/* Select the second vector layer (features to split) */}
          <select
            onChange={(e) => setSelLayer2(e.target.value)}
            value={selLayer2}
            className="form-select text-white mt-3 swipe-options" style={{ marginBottom: "5px", backgroundColor:'transparent', border:'2px solid white', fontSize: '13px' }}
          >
            <option value="">Select Second Vector Layer</option>
            {vectors.map((comp) => (
              <option key={comp} value={comp}>
                {comp}
              </option>
            ))}
          </select>

          <div>
            <button className='btn btn-primary border-0 mt-2' style={{ width: '98%', height: '30px', fontSize: '13px' }} onClick={split}>
              Split Here
            </button>
            {/* <button className='btn btn-primary border-0 mt-2' style={{ width: '98%', height: '30px', fontSize: '13px' }} onClick={splitDownload}>
              Download
            </button> */}
          </div>
        {/* </div>
      )} */}
    </div>
  );
}

export default SpiltVetorLayers;
